import { render } from "./TemplateFormPanel.vue?vue&type=template&id=786d4dd6&scoped=true"
import script from "./TemplateFormPanel.vue?vue&type=script&lang=js"
export * from "./TemplateFormPanel.vue?vue&type=script&lang=js"

import "./TemplateFormPanel.vue?vue&type=style&index=0&id=786d4dd6&lang=scss&scoped=true"
import "./TemplateFormPanel.vue?vue&type=style&index=1&id=786d4dd6&lang=scss"
script.render = render
script.__scopeId = "data-v-786d4dd6"

export default script